import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ImageEditor from '../views/ImageEditor.vue'
import VueCutterEditor from '../views/VueCutterEditor.vue'
import cutter from '../views/cutterPage/corpper.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: cutter
  },
  {
    path: '/index',
    name: 'image-editor',
    component: ImageEditor
  },
  {
    path: '/vue-cutter',
    name: 'vue-cutter',
    component: VueCutterEditor
  },
  {
    path: '/cutter',
    name: 'cutter',
    component: cutter
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router